// client.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private apiUrl;

    constructor(private http: HttpClient) {
        this.apiUrl = environment.gyanApiUrl + 'admin/v1';
    }

    // Create a new client
    createUser(userData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/register-user`, userData);
    }
    updateUser(userData: any): Observable<any> {
        return this.http.put(`${this.apiUrl}/updateuser`, userData);
    }
    // Get all clients
    getClients(clientList: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/client-list`, clientList);
    }
    // Get all clients
    getUser(userList: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/users`, userList);
    }
    // getVerifyisUserExist(email: any): Observable<any> {
    //     return this.http.get(`${this.apiUrl}/verifyemail?emailId=` + email);
    // }

    getVerifyisUserExist(email: any): Observable<any> {
        const payload = { emailId: email }; // Prepare the payload
        return this.http.post(`${this.apiUrl}/verifyemail`, payload);
    }
    // Updated POST request for verifying user existence
    verifyUserExistence(email: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/verifyemail`, email);
    }
    getUsergroup(usergroupData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/user-groups`, usergroupData);
    }

    getUsergroupType(usergroupData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/user-group-type`, usergroupData);
    }
    getDropdown1Data(): Observable<Array<any>> {
        return this.http.get<Array<any>>(`${this.apiUrl}/register-user`);
    }
    getUserRoles(): Observable<any> {
        return this.http.get(`${this.apiUrl}/users-role`);
    }
}

// userRole:string;
